import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'
import axios from 'axios'
import moment from 'moment'

class SlotAdd extends React.Component {
  state = {
    start_date: '',
    end_date: '',
    isSaving: false,
    isData: false,
    Edit: false,
  }

  componentDidMount() {
    const today = new Date().toISOString().slice(0, 10)
    this.setState({ startingDate: today, endingDate: today })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
    if (event.target.name == 'start_date') {
      if (event.target.value) {
        this.setState({
          endingDate: new Date(moment(event.target.value, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD'))
            .toISOString()
            .slice(0, 10),
        })
      } else {
        this.setState({ endingDate: '' })
      }
    }
  }

  onSaveData = () => {
    var that = this

    let data = {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      chalet_id: this.props.source_id,
    }

    let startDate = moment(data.start_date, 'YYYY-MM-DD')
    let endDate = moment(data.end_date, 'YYYY-MM-DD')

    const maxDate = moment(startDate).add(180, 'd')

    if (endDate > maxDate) {
      Swal.fire({
        title: 'Invalid Dates',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return
    }

    that.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/chalet/add-slots', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        that.setState({ isData: false })
        if (res.status === 200) {
          Swal.fire('Added !', `Slots has been Added`, 'success')
          window.history.back()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    id="start_date"
                    onChange={this.handleChange}
                    value={this.state.start_date}
                    min={this.state?.startingDate}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    id="end_date"
                    onChange={this.handleChange}
                    value={this.state.end_date}
                    min={this.state?.endingDate}
                  />
                  <div style={{ color: 'red' }}>Dates can be generated not more than 6 months</div>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/chalet-slot/${this.props.source_id}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default SlotAdd
